"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styleModule = _interopRequireDefault(require("./style.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Input = function Input(props) {
  var name = props.name,
      className = props.className,
      id = props.id,
      type = props.type,
      _onChange = props.onChange,
      value = props.value,
      required = props.required,
      placeholder = props.placeholder;
  return _react.default.createElement("input", {
    name: name,
    type: type,
    id: id,
    defaultValue: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    className: "".concat(_styleModule.default.input, " ").concat(className),
    required: required,
    placeholder: placeholder
  });
};

Input.defaultProps = {
  type: "text",
  id: "",
  value: "",
  className: "",
  placeholder: "",
  onChange: function onChange(value) {
    return value;
  },
  required: false
};
Input.propTypes = {
  name: _propTypes.default.string.isRequired,
  type: _propTypes.default.string,
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  required: _propTypes.default.bool,
  placeholder: _propTypes.default.string
};
var _default = Input;
exports.default = _default;